export default __webpack_public_path__ + "static/media/sd-event-4.b0c099a0.png";